import { render, staticRenderFns } from "./SignInSignUpView.vue?vue&type=template&id=72d503fa&scoped=true&"
import script from "./SignInSignUpView.vue?vue&type=script&lang=ts&"
export * from "./SignInSignUpView.vue?vue&type=script&lang=ts&"
import style0 from "./SignInSignUpView.vue?vue&type=style&index=0&id=72d503fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d503fa",
  null
  
)

export default component.exports